import { CurrentDate } from "./CurrentDate";

export function Header({ title, subtitle, breadcrumb }) {
  return (
    <div className="box mb-2" style={{ color: "white" }}>
      {/* Top Row */}
      <div className="d-flex justify-content-between align-items-start">
        {/* Title Section */}
        <div>
          {title && (
            <h2
              className="fw-bold mb-1"
              style={{ color: "white", fontSize: "3rem" }}
            >
              {title}
            </h2>
          )}

          {subtitle && (
            <h5 className="fw-semibold mb-0" style={{ color: "white" }}>
              {subtitle}
            </h5>
          )}
        </div>

        {/* Date Top Right */}
        <CurrentDate />
      </div>

      {/* Breadcrumb (Below) */}
      {breadcrumb && (
        <p
          className="mt-2 mb-0"
          style={{
            color: "#0f172a", // dark slate (better than pure black)
            fontWeight: 600,
            fontSize: "0.95rem",
            letterSpacing: "0.5px",
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: "6px",
          }}
        >
          {breadcrumb?.split(" > ").map((item, index, arr) => (
            <span
              key={index}
              style={{
                display: "flex",
                fontWeight: "900",
                alignItems: "center",
                gap: "6px",
              }}
            >
              <span
                style={{
                  opacity: index === arr.length - 1 ? 1 : 0.8,
                  cursor: index === arr.length - 1 ? "" : "pointer",
                }}
              >
                {item}
              </span>

              {index !== arr.length - 1 && (
                <span style={{ opacity: 0.5 }}>{">"}</span>
              )}
            </span>
          ))}
        </p>
      )}
    </div>
  );
}
